import _ from 'lodash'
import $ from 'jquery'

/**
 * Returns true if there is a text selection and the selected text is in the
 * selected element (including both itself and descendants).
 *
 * Coupled with a mouseup/click event, this implies that the user just selected text.
 * Can be used to ignore click events that would otherwise close tooltips that
 * should remain open (#24896)
 */
function isSelectionInElement (el) {
	let selection = window.getSelection()

	if (!selection) {
		return false
	}

	if (_.isEmpty(selection.toString())) {
		// Ignore the selection if there isn't any actual text selected
		// (happens when clicking on any text DOM node)
		return false
	}

	let selectedNode = _.get(selection, 'anchorNode')
	if (selectedNode) {
		return el === selectedNode || $.contains(el, selectedNode)
	} else {
		return false
	}
}

export default isSelectionInElement

isSelectionInElement.__filename__ = 'components/is-selection-in-element.js'
